export default "__VITE_ASSET__D3_U4e9D__"